export const isIntlCountry = (countryCode) => {
  return !["US", "USA", "CA", "CAN"].includes(countryCode.toUpperCase());
};

export const getState = (countryCode, state) => {
  return isIntlCountry(countryCode) ? "INTL" : state;
};

// cache used for the function getCountryInfo
const countryInfoCache = {};
/**
 * Function to get for more details on country name (mainly for US and CA), others will return minimal amount of details
 * e.g. getCountryInfo("United States of America");
 * e.g. getCountryInfo("US");
 * e.g. getCountryInfo("USA");
 * e.g. getCountryInfo("en_US");
 * @param {string} inCountry - string that can be full name of the country, short name, long name or locale
 * @return {Object} - more details about the input country:
 *    - shortName (US)
 *    - long Name (USA)
 *    - locale (en_US)
 *    - fullName (United States of America)
 *    - altName (United States)
 *    - sl (US)
 *    - isNA (true)
 */
export const getCountryInfo = (inCountry) => {
  // retrieve from cache if available (before sanitizing)
  if (countryInfoCache?.[inCountry]) {
    return countryInfoCache[inCountry];
  }

  const sanitizedCountry = decodeURI(inCountry).trim();

  // retrieve from cache if available (after sanitizing)
  if (countryInfoCache?.[sanitizedCountry]) {
    return countryInfoCache[sanitizedCountry];
  }

  let details = {
    query: sanitizedCountry,
    isNA: false,
    cached: false
  };
  if (
    /^(en(_|-)us|usa?|united states( of america)?)$/i.test(sanitizedCountry)
  ) {
    details = {
      ...details,
      shortName: "US",
      longName: "USA",
      locale: "en_US",
      fullName: "United States of America",
      altName: "United States",
      sl: "US",
      isNA: true
    };
  } else if (/^((en|fr)(_|-)ca|can?|canada)$/i.test(sanitizedCountry)) {
    details = {
      ...details,
      shortName: "CA",
      longName: "CAN",
      locale: ["en_CA", "fr_CA"],
      fullName: "Canada",
      altName: "Canada",
      sl: "CA",
      isNA: true
    };
  }

  // store in cache
  if (!countryInfoCache?.[sanitizedCountry]) {
    countryInfoCache[sanitizedCountry] = {
      ...details,
      cached: true
    };
  }

  return details;
};
